import React from 'react';
import PropTypes from 'prop-types';
import {  DialogTitle, IconButton } from '@mui/material';
import Close from '@mui/icons-material/Close';
import { styleToolBar } from '../../Tool/Style';

export const TituloDialogoBoostrap = (props) => {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    style={styleToolBar.IconButton}
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8
                    }}>
                    <Close style={styleToolBar.Icon} />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

TituloDialogoBoostrap.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};